import { render } from "./SituacaoAtualPMA.vue?vue&type=template&id=3931318a&scoped=true"
import script from "./SituacaoAtualPMA.vue?vue&type=script&lang=js"
export * from "./SituacaoAtualPMA.vue?vue&type=script&lang=js"

import "./SituacaoAtualPMA.vue?vue&type=style&index=0&id=3931318a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3931318a"]])

export default __exports__